import React from 'react';
import {
  Header,
  Hero,
  ProcessSection,
  FeaturesSection,
  IntegrationSection,
  BenefitsSection,
  CTASection,
  Footer
} from '../../components/landing';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <BenefitsSection />
        <ProcessSection />
        <FeaturesSection />
        <IntegrationSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
